export default "__VITE_ASSET__eebd85ec__"